import defaultReducer from "./defaultReducer";
import { defaultGrid } from "../../helpers/datagrid";

const initialState = { 
    title: "Cash In Box",
    open: false,
    ...defaultGrid,
    onRefresh: () => { }
}

export default defaultReducer('SITE_DETAILS_MODAL', initialState);